"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const core_1 = require("@material-ui/core");
const react_1 = tslib_1.__importStar(require("react"));
const react_redux_1 = require("react-redux");
const style_1 = tslib_1.__importDefault(require("src/app/auto-ml/utils/style"));
const icons_1 = require("../../../../../utils/icons");
const themes_1 = require("../../../../../utils/themes");
function PreprocessingStep4RCAMultistep(props) {
    const { setFeatureMapping, featureMapColumn, setColumnNameError, columnNameError } = props;
    const columns = react_redux_1.useSelector((state) => state.columnSelectionS22); // Get column names
    const [renameValue, setRenameValue] = react_1.useState("");
    const [editingColumn, setEditingColumn] = react_1.useState(null); // Track which column is being edited
    const binaryThresholding = react_redux_1.useSelector((state) => state.binary_thresholding);
    const featureMapping = react_redux_1.useSelector((state) => state.feature_mapping_data);
    const [featureData, setFeatureData] = react_1.useState(featureMapping);
    const [featureMap, setFeatureMap] = react_1.useState({});
    const [selectedColumn, setSelectedColumn] = react_1.useState([]);
    const [renameColumns, setRenameColumns] = react_1.useState([]);
    const styleLocal = style_1.default();
    console.log("Step 4 RCA", binaryThresholding);
    console.log('feture mapping', featureMapping);
    // Combine all column arrays into one array
    const allColumns = [
        ...columns.selectedCategoricalColumns,
        ...columns.selectedNumericalColumns,
        ...columns.selectedDateTime,
        ...columns.selectedIndexColumns,
        ...columns.remainingColumns
    ];
    react_1.useEffect(() => {
        setFeatureData((prevData) => (Object.assign({}, prevData, { feature_mapping_data: {
                rename_columns: featureMap,
                drop_columns: selectedColumn
            } })));
    }, [featureMap, selectedColumn]);
    react_1.useEffect(() => {
        setFeatureMapping({
            rename_columns: featureMap,
            drop_columns: selectedColumn
        });
    }, [featureData, setFeatureMapping, featureMap, selectedColumn]);
    react_1.useEffect(() => {
        console.log(featureMapColumn);
        setRenameColumns(featureMapColumn);
    }, [featureMapColumn]); // Add columns as a dependency
    const handleColumnChange = (value) => {
        setSelectedColumn((prevSelectedColumns) => {
            if (prevSelectedColumns.includes(value)) {
                return prevSelectedColumns.filter((column) => column !== value); // Remove
            }
            else {
                return [...prevSelectedColumns, value]; // Add
            }
        });
        setRenameColumns((prevSelectedColumns) => {
            if (prevSelectedColumns.includes(value)) {
                return prevSelectedColumns.filter((column) => column !== value);
            }
            else {
                return [...prevSelectedColumns, value];
            }
        });
    };
    const handleRenameChange = (event, index) => {
        setRenameValue(event.target.value);
        setColumnNameError(""); // Clear error while typing
    };
    const handleRenameBlur = () => {
        const trimmedName = renameValue.trim();
        if (renameColumns.includes(trimmedName) && renameColumns[editingColumn] !== renameValue) {
            setColumnNameError("Column name should be unique.");
        }
        else {
            setColumnNameError("");
        }
    };
    const handleEditClick = (column, index) => {
        if (editingColumn != null) {
            setColumnNameError("Please save the name.");
            return;
        }
        setEditingColumn(index);
        setRenameValue(column);
    };
    const handleSaveRename = () => {
        if (renameValue !== "" && editingColumn !== null && (columnNameError == "" || columnNameError == "Please save the name.")) {
            console.log(`Renamed Column: ${editingColumn} to ${renameValue}`);
            // Find the column and update its name
            const updatedRenameColumns = renameColumns.map((col, index) => index === editingColumn ? renameValue : col);
            setFeatureMap((prevMap) => (Object.assign({}, prevMap, { [renameColumns[editingColumn]]: renameValue })));
            setRenameColumns(updatedRenameColumns);
            // Clear the editing state after saving
            setEditingColumn(null);
            setRenameValue('');
            setColumnNameError('');
        }
        else {
            console.log('rename error', renameValue, editingColumn, columnNameError);
            return;
        }
    };
    return (react_1.default.createElement(core_1.Grid, { container: true, spacing: 2 },
        react_1.default.createElement(core_1.Typography, { className: styleLocal.topicFont, component: "span", style: { padding: "20px 28px" } }, "Rename features as needed and drop any features you want to exclude from further processing."),
        react_1.default.createElement(core_1.Grid, { item: true, lg: 12, xs: 12, sm: 12, md: 12 },
            react_1.default.createElement(core_1.Box, { sx: { padding: "10px", backgroundColor: "white", borderRadius: 1, padding: "40px" } },
                react_1.default.createElement(core_1.Grid, { container: true, display: "flex", className: styleLocal.renameColumnDiv }, renameColumns && renameColumns.map((column, index) => (react_1.default.createElement(core_1.Grid, { item: true, xs: 3, md: 3, style: { marginBottom: '15px' }, key: index },
                    react_1.default.createElement(core_1.Box, { display: "flex", alignItems: "flex-start", key: index, className: styleLocal.renameColumn }, editingColumn === index ? (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(core_1.TextField, { value: renameValue, onChange: (e) => handleRenameChange(e, index), style: { paddingRight: "10px", flex: 1, borderColor: '#E2E5ED' }, InputProps: {
                                style: {
                                    height: "38px",
                                    fontWeight: 400,
                                    fontSize: '13px'
                                },
                            }, fullWidth: true, size: "small", variant: "outlined", onBlur: handleRenameBlur, error: !!columnNameError, helperText: columnNameError }),
                        react_1.default.createElement(core_1.Button, { onClick: handleSaveRename, disabled: !renameValue, variant: "contained", className: styleLocal.saveColumnButton }, "save"))) : (react_1.default.createElement(core_1.Chip, { key: index, size: "medium", className: styleLocal.columnChip, style: {
                            background: 'none',
                            border: '0.6px solid #868DAA',
                            borderRadius: '4px',
                            height: '48px'
                        }, onMouseDown: (event) => event.stopPropagation(), onChange: () => handleEditClick(column, index), onDelete: (event) => {
                            event.stopPropagation();
                            handleColumnChange(column);
                        } // Toggle value on delete
                        , label: react_1.default.createElement(core_1.Box, { display: "flex", alignItems: "center" },
                            react_1.default.createElement(core_1.Typography, { variant: "body2", style: { marginRight: 4 } }, column),
                            react_1.default.createElement(core_1.IconButton, { size: "small", onClick: () => handleEditClick(column, index) },
                                react_1.default.createElement(icons_1.EditNameIcon, null))) }))))))),
                react_1.default.createElement(core_1.Grid, { container: true },
                    react_1.default.createElement(core_1.Typography, { variant: "h6", style: { marginBottom: "20px", fontFamily: "Poppins" } }, "Drop Column"),
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 12, md: 12, style: { height: "40px" } },
                        react_1.default.createElement("div", { style: themes_1.remainingColumnDiv }, selectedColumn.length > 0 ? (selectedColumn.map((column, index) => (react_1.default.createElement(core_1.Chip, { label: column, key: index, style: themes_1.remaingColumnChip, onDelete: (event) => {
                                event.stopPropagation();
                                handleColumnChange(column);
                            } })))) : (react_1.default.createElement(core_1.Typography, { style: { padding: "14px 8px", color: "#868DAA", fontSize: "16px" } }, "No columns selected")))))))));
}
exports.PreprocessingStep4RCAMultistep = PreprocessingStep4RCAMultistep;
//# sourceMappingURL=pre-processing-step4-rca_ms.js.map